import React, { useEffect, useState } from "react";
import style from "./dashboard.module.scss";
import Skeleton from "../skeleton/skeleton"

const DashBoardSkeleton = (props) => {

    return <div style={{ display: 'inline-flex', flexDirection: 'row', flexWrap: 'wrap', gap: '25px', width: '100%' }}>
        <div style={{ width: '48%' }}>
            <h2><Skeleton type='rectangle' width='100px' height='40px' /></h2>

            <div className={style.canvasWrapper}>
                <Skeleton type='rectangle' width='100%' height='300px' />
            </div>
            <div className={style.totalCost} style={{ marginTop: '10px' }}>
                <Skeleton type='rectangle' width='100%' height='30px' />
            </div>
        </div>
        <div style={{ width: '48%' }}>
            <h2><Skeleton type='rectangle' width='100px' height='40px' /></h2>

            <div className={style.canvasWrapper}>
                <Skeleton type='rectangle' width='100%' height='300px' />
            </div>
            <div className={style.totalCost} style={{ marginTop: '10px' }}>
                <Skeleton type='rectangle' width='100%' height='30px' />
            </div>
        </div>
    </div>
}
export default DashBoardSkeleton;
